export const SIDEBAR_ITEMS = [];
